<template>
	<div>
		<div class="ser_team common_style">
			<headerPanel
				title="服务团队"
				:componentType="servicePersonnel"
				:query="getpersonnelInfo"
				hideBorder
			>
			</headerPanel>
		</div>
		<div class="pro_content common_style">
			<headerPanel
				title="推广内容"
				:subtitle="explainone"
				buttonName="我想修改"
				:buttonClick="() => toSkip(1)"
				hideBorder
				:componentType="pContent"
				:query="getContentData"
				:hidebutton="isShow"
			>
			</headerPanel>
		</div>
		<div class="common_style">
			<!-- 取消俄罗斯注释 -->
			<!-- <headerPanel
				title="推广国家地区及预算"
				:subtitle="explainTwo"
				:tipText="tiptwo"
				buttonName="我想修改"
				:buttonClick="() => toSkip(4)"
				hideBorder
				:componentType="countryAndBudgetVal"
				:query="productregion"
				:hidebutton="!isfinish"
			>
			</headerPanel> -->
			<headerPanel
				title="推广国家地区及预算"
				:subtitle="explainTwo"
				buttonName="我想修改"
				:buttonClick="() => toSkip(4)"
				hideBorder
				:componentType="countryAndBudgetVal"
				:query="productregion"
				:hidebutton="isShow"
			>
			</headerPanel>
		</div>
		<div class="common_style">
			<headerPanel
				title="广告附加信息"
				:tipText="explainThree"
				buttonName="我想修改"
				:buttonClick="() => toSkip(5)"
				hideBorder
				:componentType="addinfo"
				:query="productadditional"
				:hidebutton="isShow"
			>
			</headerPanel>
		</div>
		<confirmStep :activeValue="6" class="footer" v-if="isShow"></confirmStep>
	</div>
</template>

<script>
import addinfo from '../com/p-addinfo.vue';
import countryAndBudgetVal from '../com/p-countryAndBudgetVal.vue';
import adsNewOnlineSer from '@/backend/services/adsNewOnline/adsNewOnlineSer.js';
import servicePersonnel from '@/components/adsOnlineAuto/com/servicePersonnel.vue';
import pContent from '@/components/adsOnlineAuto/com/p-content.vue';
import headerPanel from '@/components/client/clientModule/headerPanel';
import confirmStep from '@/components/adsOnlineAuto/confirmStep';
export default {
	data() {
		return {
			servicePersonnel,
			pContent,
			countryAndBudgetVal,
			addinfo,
			explainone:
				'您可以选择网站上的产品分类或产品作为广告投放的目标，采购商点击广告后会跳转至相应的产品页面。',
			explainTwo:
				'Google 必须遵守美国财政部外国资产控制办公室 (OFAC) 实施的制裁。因此，部分国家或地区（随附条件 ID）的广告客户无法使用 Google Ads。',
			// 取消俄罗斯注释
			// tiptwo:"苏丹 (2736)<br/><div>注：虽然没有列出俄罗斯，但是目前俄罗斯也被制裁无法投放。</div>",
			explainThree:
				'通过在您的广告中添加更多内容，附加信息可提高广告的醒目程度，使其在搜索结果页上更加显眼，通过额外信息扩展您的广告，以便为用户提供更多理由来选择您。请注意：附加信息是概率性展示，添加附加信息并不能保证附加信息一定会始终随您的广告一同展示。',
		};
	},
	components: { headerPanel, confirmStep },

	computed: {
		queryParam() {
			return this.$route.query;
		},
		isShow() {
			return this.$route.query.isShow == '0' ? false : true;
		},
		id() {
			return this.$route.query.id;
		},
	},

	methods: {
		toSkip(val) {
			this.$emit('toSkip', val);
		},
		//推广内容
		async getContentData() {
			let res = await adsNewOnlineSer.productdetailList({
				id: this.id,
			});
			return {
				data: res.data,
			};
			// let res = await adsNewOnlineSer.getproduct({
			// 	id: id,
			// });
			// let classifyList = res.data.productTypeList;
			// let prdData = res.data.productList;
			// return {
			// 	data: classifyList.concat(prdData),
			// };
		},
		//关键字
		async prdkeywordList() {
			let res = await adsNewOnlineSer.prdkeywordList({
				id: this.id,
			});
			return res.data.removeKeywordList;
		},
		//地区与预算
		async productregion() {
			let res = await adsNewOnlineSer.productregion({
				id: this.id,
			});
			return {
				importantRegionList: res.data.importantRegionList,
				removeRegionList: res.data.removeRegionList,
				budgetVal: res.data.budgetVal,
        regionId: res.data.regionId,
			};
		},
		//广告附加信息
		async productadditional() {
			let res = await adsNewOnlineSer.productadditional({
				id: this.id,
			});
			return {
				propagandaList: res.data.propagandaList,
				structureList: res.data.structureList,
				webpageList: res.data.webpageList,
			};
		},
		async getpersonnelInfo() {
			let res = await adsNewOnlineSer.getPersonnel({
				serviceSiteId: this.queryParam.serviceSiteId,
			});
			if (res.data) {
				let { googleStaff, salesStaff, siteStaff } = res.data;
				let staffArray = [];
				if (googleStaff) {
					staffArray.push(googleStaff);
				}
				if (salesStaff) {
					staffArray.push(salesStaff);
				}
				if (siteStaff) {
					staffArray.push(siteStaff);
				}
				return {
					personnelInfo: staffArray,
				};
			}
		},
	},
	mounted() {
		this.getpersonnelInfo();
	},
};
</script>

<style lang="scss" scoped>
.common_style {
	background: #ffffff;
	box-shadow: 0px 4px 4px 0px rgba(67, 93, 255, 0.05);
	border-radius: 4px;
	margin-top: 10px;
}
.ser_team {
	height: 223px;
}
.pro_content {
	height: auto;
}
</style>
